import { isObject, isEqual } from 'lodash';
import { AnyType } from '@src/models/common';
import { ILocalAccount, IMenuAccount } from '@src/models/account';
import { IProfile, TLinkedUser } from '@src/models/auth';

export const isPartialEqual = (source: Record<string, AnyType>, target: Record<string, AnyType>) => {
  if (!isObject(source) || !isObject(target)) return false;

  for (const [key, value] of Object.entries(source)) {
    if (!isEqual(target[key], value)) return false;
  }

  return true;
};

export const mergeProfileAndAccounts = (store: IProfile | null, accountsList: ILocalAccount[]) => {
  if (!store || !accountsList || !accountsList.length) return [] as IMenuAccount[];

  const { linkedUsers } = store;

  return accountsList.reduce<IMenuAccount[]>((result, a) => {
    const idNumber = Number.parseInt(a.id as string);

    /** Показываем только неактивные аккаунты */
    if (a.active) return result;

    const update = linkedUsers.find((acc) => acc.id === idNumber);

    if (update) {
      result.push({
        ...update,
        ...a,
        id: idNumber,
      });
    } else {
      /** Если аккаунт есть в списке в localStorage но его нет у текущего пользователя значит вход в этот аккаунт был выполнен ранее.
       * Такие аккаунты отображаются серыми в списке. */
      result.push({
        ...a,
        id: idNumber,
        linked: false,
      });
    }

    return result;
  }, []);
};

export const getAccountDataFromUser = (user: TLinkedUser, rest: Partial<ILocalAccount> = {}) => {
  return {
    id: user.id,
    update: {
      ...rest,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      /** Нет смысла хранить целый объект, берем только ссылку */
      avatarUrl: user.avatar?.imageSizeUrls?.thumb || user.avatar?.mainUrl,
    },
  };
};
